module.exports = __webpack_public_path__ + "media/images/vehicles/absetzkipper-da1447b87110df1c66f630bc2ca81f24.png";